export default __webpack_public_path__ + "static/media/gallery - polyjuice_01.557afd69.jpg";